import BaseInput from "./BaseInput";
import Input from "./Input";
export { BaseInput };
export default Input;